import { render, staticRenderFns } from "./MyAccountUpdate.vue?vue&type=template&id=a4788d56&scoped=true"
import script from "./MyAccountUpdate.vue?vue&type=script&lang=js"
export * from "./MyAccountUpdate.vue?vue&type=script&lang=js"
import style0 from "./MyAccountUpdate.vue?vue&type=style&index=0&id=a4788d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4788d56",
  null
  
)

export default component.exports